import axiosConfig from "./axiosConfig";

export interface LeadResearchCostTotals {
  runCount: number;
  testRunCount: number;
  modelUsd: number;
  webSearchUsd: number;
  totalUsd: number;
  webSearchCount: number;
}

export interface LeadResearchCostRun {
  id: string;
  createdAt: string;
  // Which lead-pipeline surface the spend came from (the AI-invocation ledger
  // `source` label, e.g. landlord-research vs people-discovery). The card routes
  // the trace link by this.
  source: string | null;
  // The trace subject ref (prompt-test:<ref> for a test run, the raw ref for a
  // live run) - also the first half of the trace lookup key.
  subjectRef: string | null;
  isTest: boolean;
  failed: boolean;
  webSearchCount: number;
  modelUsd: number;
  webSearchUsd: number;
  totalUsd: number;
  traceSubjectRef: string | null;
  traceRunId: string | null;
}

export interface LeadResearchCostSourceTotals {
  runCount: number;
  totalUsd: number;
}

export interface LeadResearchCostsResponse {
  windowDays: number;
  generatedAt: string;
  // Costs are ESTIMATES computed from per-model token + web-search counts on read.
  webSearchUsdPerQuery: number;
  totals: LeadResearchCostTotals;
  // Spend split by lead-pipeline surface (source label -> run count + $), so the
  // card can show landlord-research vs people-discovery separately.
  bySource: Record<string, LeadResearchCostSourceTotals>;
  recent: LeadResearchCostRun[];
  truncated: boolean;
}

const getLeadResearchCosts = async (
  authToken: string,
  days: number
): Promise<LeadResearchCostsResponse> => {
  const { data } = await axiosConfig.get(`/leads/research-costs`, {
    params: { days },
    headers: { Authorization: `Bearer ${authToken}` },
  });
  return data;
};

export default getLeadResearchCosts;
